module.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/


//////////////////
// WEBPACK FOOTER
// ./~/uc.micro/properties/Any/regex.js
// module id = 364
// module chunks = 35783957827783